import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import IconIncome from '@mui/icons-material/NorthEastRounded';
import IconExpense from '@mui/icons-material/SouthWestRounded';
import IconEdit from '@mui/icons-material/EditOutlined';
import IconDelete from '@mui/icons-material/DeleteOutlineRounded';
import IconLabel from '@mui/icons-material/LocalOfferOutlined';
import RowAction from '../../../components/RowAction';
import EmptyState from '../../../components/EmptyState';
import styles from './CategoryColumn.module.css';

const TYPES = {
    income: {
        title: 'Receitas',
        subtitle: 'De onde o dinheiro entra',
        icon: <IconIncome fontSize="small" />,
        tone: 'green',
        empty: 'Ex.: atendimentos, pacotes, vendas.'
    },
    expense: {
        title: 'Despesas',
        subtitle: 'Para onde o dinheiro sai',
        icon: <IconExpense fontSize="small" />,
        tone: 'rose',
        empty: 'Ex.: aluguel, materiais, impostos.'
    }
};

/** Card de uma coluna (Receitas ou Despesas) com as categorias, editar e excluir em ícone. */
function CategoryColumn({ type, categories, hiddenCount = 0, isLoading, onEdit, onDelete }) {
    const config = TYPES[type];

    return (
        <section className={`${styles.card} ${styles[config.tone]}`}>
            <div className={styles.head}>
                <span className={styles.headIcon}>{config.icon}</span>
                <div className={styles.headTexts}>
                    <h3 className={styles.title}>{config.title}</h3>
                    <span className={styles.subtitle}>{config.subtitle}</span>
                </div>
                {!isLoading && (
                    <span className={styles.count}>{categories.length}</span>
                )}
            </div>

            {isLoading ? (
                <div className={styles.list}>
                    {[0, 1, 2].map(key => (
                        <div key={key} className={styles.row}>
                            <Skeleton variant="circular" width={30} height={30} />
                            <Skeleton variant="text" width="45%" />
                        </div>
                    ))}
                </div>
            ) : categories.length === 0 ? (
                <EmptyState
                    compact
                    tone={config.tone}
                    icon={<IconLabel />}
                    title={hiddenCount > 0 ? 'Só há categorias inativas' : 'Nenhuma categoria aqui ainda'}
                    text={hiddenCount > 0 ? 'Ligue "Exibir inativos" para vê-las.' : config.empty}
                />
            ) : (
                <ul className={styles.list}>
                    {categories.map(category => (
                        <li
                            key={category.id}
                            className={`${styles.row} ${!category.isActive ? styles.inactive : ''}`}
                        >
                            <span className={styles.rowIcon}><IconLabel style={{ fontSize: 16 }} /></span>
                            <span className={styles.name}>{category.name}</span>
                            <span className={`${styles.status} ${category.isActive ? styles.statusActive : styles.statusInactive}`}>
                                {category.isActive ? 'Ativo' : 'Inativo'}
                            </span>
                            <RowAction title="Editar categoria" onClick={() => onEdit(category)}>
                                <IconEdit style={{ fontSize: 17 }} />
                            </RowAction>
                            <RowAction
                                title={Number(category.usageCount) > 0 ? 'Em uso: só pode ser inativada' : 'Excluir categoria'}
                                tone="danger"
                                onClick={() => onDelete(category)}
                            >
                                <IconDelete style={{ fontSize: 17 }} />
                            </RowAction>
                        </li>
                    ))}
                </ul>
            )}
        </section>
    );
}

export default CategoryColumn;
